import * as ActionTypes from './types.action';

export const setProfile = account => ({
  type: ActionTypes.SET_PROFILE_SUCCESS,
  account,
});
